export const anything = <T> (x: T) => x;
